import { DataSensor } from './data-sensor.js'
import { DataSensorQuery } from './data-sensor-query.js'
import { DataSensorMutation } from './data-sensor-mutation.js'

export const entities = [DataSensor]
export const resolvers = [DataSensorQuery, DataSensorMutation]
